import styled from "styled-components";

export const Message = styled.div.withConfig({
    shouldForwardProp: (prop) => prop !== "sentiment"
})<{ sentiment: boolean }>`
    margin-top: 1rem;
    max-width: 22rem;
    background-color: ${props => props.sentiment ? "rgba(82, 181, 75, 0.15)" : "rgba(229, 83, 75, 0.15)"};
    color: ${props => props.sentiment ? "var(--color-success)" : "var(--color-danger)"};
    border: 1px solid ${props => props.sentiment ? "var(--color-success)" : "var(--color-danger)"};
    text-align: center;
    padding: 0.5rem;
    border-radius: 0.4rem;
    font-size: 0.85rem;
`;
